import axios from "axios";
import distributorsRequest from "axios/distributorsRequest";
import { base64ToBlob, publicIp } from "utils";

import {
  ACCOUNT_INFO,
  ACCOUNT_AVATAR,
  AUTH_LOGOUT as AUTH_LOGOUT_URL,
} from "../../../constants/api";
import { SESSION_EXPIRED_ERROR, FUNDS_PROPERTY_NAME } from "../../../constants";
import { cleanStore } from "redux/actions";
import {
  stopFundsAutoUpdate,
  startFundsAutoUpdate,
} from "redux/app/actions/funds.action";
import history from "routes/history";
import { AUTH_ROOT_ROUTE, LOGIN_ROUTE } from "routes/auth/authPaths";

export const AUTH_ADD_PUBLIC_IP = "auth/addPublicIp";
export const AUTH_ADD_SESSION_DATA = "auth/addSessionData";
export const AUTH_REMOVE_SESSION_DATA = "auth/removeSessionData";
export const AUTH_FETCH_USER_STARTED = "auth/fetchUserStarted";
export const AUTH_FETCH_USER_SUCCESS = "auth/fetchUserSuccess";
export const AUTH_FETCH_USER_FAILURE = "auth/fetchUserFailure";
export const AUTH_ADD_AVATAR = "auth/addAvatar";
export const AUTH_PHONE_VALIDATED_SUCCESS = "auth/phoneValidatedSuccess";

export const authAddPublicIp = () => async (dispatch) => {
  const userPublicIp = await publicIp.getIPs(1000);
  dispatch({ type: AUTH_ADD_PUBLIC_IP, payload: { publicIp: userPublicIp } });
};

const authAddSessionData = ({ operator }) => ({
  type: AUTH_ADD_SESSION_DATA,
  payload: { operator },
});

export const authSaveSessionData =
  ({ token, operator, accessToken }) =>
  async (dispatch) => {
    localStorage.setItem("apiToken", token);
    localStorage.setItem("ttl", Date.now());
    if (accessToken) {
      localStorage.setItem("sso", JSON.stringify(accessToken));
    }
    operator
      ? localStorage.setItem("operator", JSON.stringify(operator))
      : localStorage.removeItem("operator");

    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    distributorsRequest.defaults.headers.common.Authorization = `Bearer ${token}`;

    await dispatch(authAddSessionData({ operator }));

    dispatch(fetchLegacyUser());
    dispatch(fetchAvatar());
  };

export const authRecoverSessionData = () => async (dispatch) => {
  const apiToken = localStorage.getItem("apiToken");

  if (apiToken) {
    axios.defaults.headers.common.Authorization = `Bearer ${apiToken}`;
    distributorsRequest.defaults.headers.common.Authorization = `Bearer ${apiToken}`;
    const operator = JSON.parse(localStorage.getItem("operator"));

    await dispatch(authAddSessionData({ operator }));

    dispatch(fetchLegacyUser());
    dispatch(fetchAvatar());
  }
  dispatch(authAddPublicIp());
};

export const authLogout = (storeFrom) => (dispatch) => {
  if (axios.defaults.headers.common.Authorization) {
    axios.get(AUTH_LOGOUT_URL);
  }

  localStorage.removeItem("apiToken");
  localStorage.removeItem("operator");
  localStorage.removeItem("ttl");
  localStorage.removeItem("sso");
  localStorage.removeItem(FUNDS_PROPERTY_NAME);

  axios.defaults.headers.common.Authorization = undefined;
  distributorsRequest.defaults.headers.common.Authorization = undefined;

  dispatch({ type: AUTH_REMOVE_SESSION_DATA });
  dispatch(cleanStore());
  stopFundsAutoUpdate();
  dispatch(authAddPublicIp());
  const state = storeFrom
    ? {
        from: history.location.pathname,
      }
    : {};

  history.push(AUTH_ROOT_ROUTE + LOGIN_ROUTE, state);
};

export const fetchLegacyUser = () => async (dispatch) => {
  dispatch(fetchLegacyUserStarted());

  try {
    const accountInfoResponse = await axios.get(ACCOUNT_INFO);
    dispatch(fetchLegacyUserSuccess(accountInfoResponse?.data?.result));
    if (!accountInfoResponse?.data?.result?.operator?.operator) {
      dispatch(startFundsAutoUpdate());
    }
  } catch (e) {
    if (e.message !== SESSION_EXPIRED_ERROR) {
      dispatch(fetchLegacyUserFailure(e.message));
    }
  }
};

const fetchLegacyUserSuccess = (user) => ({
  type: AUTH_FETCH_USER_SUCCESS,
  payload: {
    ...user,
  },
});

const fetchLegacyUserStarted = () => ({
  type: AUTH_FETCH_USER_STARTED,
});

export const fetchLegacyUserFailure = (error) => ({
  type: AUTH_FETCH_USER_FAILURE,
  payload: {
    error,
  },
});

export const addAvatar = (avatar) => ({
  type: AUTH_ADD_AVATAR,
  payload: {
    avatar,
  },
});

export const fetchAvatar = () => async (dispatch) => {
  try {
    const response = await axios.get(ACCOUNT_AVATAR);
    const avatarBase64 = response.data.result;
    const avatarBlob = base64ToBlob(avatarBase64);
    const imageURL = window.URL.createObjectURL(avatarBlob);
    dispatch(addAvatar(imageURL));
  } catch (e) {
    console.error(e.message);
  }
};

export const phoneValidatedSuccess = () => ({
  type: AUTH_PHONE_VALIDATED_SUCCESS,
});
